export default __webpack_public_path__ + "tmp_src/components/Customer/customerAccount~nova.css.liquid";